// extracted by mini-css-extract-plugin
export default {"linkContainer":"DeviceOverview_linkContainer__Qq53J"};